import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { format, parse } from 'date-fns';
import { ja } from 'date-fns/locale';

const neverExpireDate = '9999-12-31';

const getExipireDateDisplay = (expirationDate) => {
  if (!expirationDate) {
    return '';
  }

  if (expirationDate === neverExpireDate) {
    return '無期限';
  }

  const parsedDate = parse(expirationDate, 'yyyy-MM-dd', new Date());
  return format(parsedDate, 'yyyy/M/d', { locale: ja });
};

const GiftCardInput = ({
  number, availableAmount, inputAmount, onChangeInputAmount, giftCardNumber,
  expirationDate, finalPriceNumber, giftCardInputTotalNumber,
}) => {
  const [input, setInput] = useState(inputAmount || '');

  useEffect(() => setInput(inputAmount), [inputAmount]);

  const handleInputChange = (value) => {
    const newInputAmount = value || '0';
    const availableAmountNumber = Number(availableAmount);
    const newInputAmountNumber = Number(newInputAmount);

    if (newInputAmountNumber > availableAmountNumber) {
      alert('利用額の入力値が残高を超えています。');
      setInput(inputAmount);
      return;
    }

    const otherGiftCardTotalNumber = giftCardInputTotalNumber - inputAmount;

    if (finalPriceNumber - otherGiftCardTotalNumber - newInputAmountNumber < 0) {
      alert('利用額の入力値が決済金額を超えています。');
      setInput(inputAmount);
      return;
    }

    return onChangeInputAmount(newInputAmountNumber.toString());
  };

  return (
    <div className="giftCardInput">
      <div className="giftCardInputItem giftCardInputNumber">{number}枚目</div>
      <div className="giftCardInputItem">
        <div>番号</div>
        <div className="giftCardInputItemCellRight">{giftCardNumber}</div>
      </div>
      <div className="giftCardInputItem">
        <div>有効期限</div>
        <div className="giftCardInputItemCellRight">{getExipireDateDisplay(expirationDate)}</div>
      </div>
      <div className="giftCardInputItem">
        <div>ギフトカード残高</div>
        <div className="giftCardInputItemCellRight">{Number(availableAmount).toLocaleString()}円</div>
      </div>

      <div className="giftCardInputItem giftCardInputItemAmount">
        <div className="giftCardInputTitle">利用額</div>
        <div className="giftCardInputUsageAmountContainer giftCardInputItemCellRight">
          <input
            id={`giftCardInput-${number}`}
            className="giftCardInputUsageAmount"
            type="text"
            pattern="\d*"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onBlur={(e) => handleInputChange(e.target.value)}
            min={0}
            max={availableAmount}
            placeholder={'利用額を入力してください'}
          />
          <span className="giftCardInputUsageAmountUnit">円</span>
        </div>
      </div>
    </div>
  );

};

GiftCardInput.defaultProps = {
};

GiftCardInput.propTypes = {
  number: PropTypes.number.isRequired,
  availableAmount: PropTypes.string.isRequired,
  inputAmount: PropTypes.string.isRequired,
  onChangeInputAmount: PropTypes.func.isRequired,
  giftCardNumber: PropTypes.string.isRequired,
  expirationDate: PropTypes.string.isRequired,
  finalPriceNumber: PropTypes.number.isRequired,
  giftCardInputTotalNumber: PropTypes.number.isRequired,
};

export default GiftCardInput;
